export const textStyle = (fontSize, fontWeight, marginTop, marginBottom) => ({
  fontSize,
  fontWeight,
  marginTop: marginTop ?? '0',
  marginBottom: marginBottom ?? '0',
});

export const selectButtonStyle = (width, marginTop) => ({
  width,
  marginTop: marginTop ?? '0px',
});
